// topTip 图片
export const topRankIcons = {
  1: 'https://cdn.poizon.com/node-common/fc8c0a4369fa6d9b4396e9b60c60c60f.png',
  // 2: 'https://cdn.poizon.com/node-common/0e847cc653c78974e5afb956cb467901.png',
  2: 'https://cdn.poizon.com/node-common/19ae8e2221e6a78db6528bf90ef148b9.png',
  3: 'https://cdn.poizon.com/node-common/9908677dbda3eb65173230c0b1a48d18.png',
  4: 'https://cdn.poizon.com/node-common/b5681f7130df5adeab208abc3776c5b0.png',
}
